
  if (document.body.classList.contains('blog')) {
  const dayButtons = document.querySelectorAll(".day-light");
  const nightButtons = document.querySelectorAll(".night-light");

  if (dayButtons.length === 0 || nightButtons.length === 0) {
  } else {

    const STORAGE_KEY = "thememode";
    const savedMode = localStorage.getItem(STORAGE_KEY);

    function setDayMode() {
      dayButtons.forEach(btn => btn.classList.add("active"));
      nightButtons.forEach(btn => btn.classList.remove("active"));
      localStorage.setItem(STORAGE_KEY, "day-light");
    }

    function setNightMode() {
      nightButtons.forEach(btn => btn.classList.add("active"));
      dayButtons.forEach(btn => btn.classList.remove("active"));
      localStorage.setItem(STORAGE_KEY, "night-light");
    }

    if (savedMode === "day-light") {
      setDayMode();
    } 
    else if (savedMode === "night-light") {
      setNightMode();
    } 
    else {
      if ([...dayButtons].some(btn => btn.classList.contains("active"))) {
        setDayMode();
      } 
      else if ([...nightButtons].some(btn => btn.classList.contains("active"))) {
        setNightMode();
      } 
      else {
        setDayMode();
      }
    }

    dayButtons.forEach(btn => {
      btn.addEventListener("click", function () {
        setDayMode();
      });
    });

    nightButtons.forEach(btn => {
      btn.addEventListener("click", function () {
        setNightMode();
      });
    });

  }

  const nightModeNodes = document.querySelectorAll(".night-light");
  const darkToggleNodes = document.querySelectorAll('[class*="darktoggle-"], [class*="darktoggle "]');
  const inverseLogo = document.querySelector('.header-logo__image-container.header-logo__image-container--inverse');
  const originalLogo = document.querySelector('.header-logo__image-container.header-logo__image-container--original');
  const nightBlog = document.querySelector('.night-blog');
  const dayBlog = document.querySelector('.day-blog');
  
  function toSpaceFormat() {
    darkToggleNodes.forEach(el => {
      el.className = el.className.replace(
        /darktoggle-([^\s]+)/g,
        "darktoggle $1"
      );
    });
    if (inverseLogo) inverseLogo.style.display = 'block';
    if (originalLogo) originalLogo.style.display = 'none';
    if (nightBlog) nightBlog.style.display = 'grid';
    if (dayBlog) dayBlog.style.display = 'none';
  }

  function toHyphenFormat() {
    darkToggleNodes.forEach(el => {
      el.className = el.className.replace(
        /darktoggle ([^\s]+)/g,
        "darktoggle-$1"
      );
    });
    if (inverseLogo) inverseLogo.style.display = 'none';
    if (originalLogo) originalLogo.style.display = 'block';
    if (nightBlog) nightBlog.style.display = 'none';
    if (dayBlog) dayBlog.style.display = 'grid';
  }

  function syncDarkToggle() {
    if (document.querySelector(".night-light.active")) {
      toSpaceFormat();
    } else {
      toHyphenFormat();  
    }
  }

  setTimeout(function(){syncDarkToggle();},1000);

  const observer = new MutationObserver(syncDarkToggle);

  nightModeNodes.forEach(node => {
    observer.observe(node, {
      attributes: true,
      attributeFilter: ["class"]
    });
  });
  }


document.querySelectorAll('.light-mode-media-container, .night-mode-media-container')
  .forEach(el => !el.querySelector('*') && (el.style.display = 'none'));

const toggleDisplay = (selectors, show) => {
  document.querySelectorAll(selectors).forEach(el => {
    el.style.display = show ? 'inline' : 'none';
  });
};

const updateMediaMode = () => {
  const isDay = document.querySelector('.day-light.active');
  toggleDisplay('.light-mode-media-container, .light-mode-content, .mobile-light-mode',isDay);

  toggleDisplay('.night-mode-media-container, .dark-mode-content', !isDay);
  Blogs_Featured()
};

// Build one mode's media container (<picture> for responsive, plain <img>
// otherwise). Returns null when the mode has no image so the caller can skip it.
function buildFeaturedMediaContainer(isNightMode, data) {
  const desktopImage = data.image_desktop || data.image;
  const mobileImage = data.image_mobile || desktopImage;
  if (!desktopImage && !mobileImage) return null;

  const container = document.createElement("div");
  container.className = isNightMode
    ? "night-mode-media-container"
    : "light-mode-media-container";

  if (mobileImage && desktopImage) {
    const picture = document.createElement("picture");
    picture.className = "hero__picture";

    const mobileSource = document.createElement("source");
    mobileSource.setAttribute("media", "(max-width: 749px)");
    mobileSource.setAttribute("srcset", mobileImage);

    const img = document.createElement("img");
    img.src = desktopImage;
    img.alt = data.title || "";
    img.className = "hero__image hero__image--desktop hero__image--mobile";

    picture.appendChild(mobileSource);
    picture.appendChild(img);
    container.appendChild(picture);
  } else {
    const img = document.createElement("img");
    img.src = desktopImage || mobileImage;
    img.alt = data.title || "";
    img.className = "hero__image hero__image--desktop hero__image--mobile";
    container.appendChild(img);
  }

  return container;
}

// Guard so the media containers are built exactly once. After that,
// updateMediaMode()/toggleDisplay only flip visibility between the two
// already-loaded containers.
let featuredMediaBuilt = false;

function Blogs_Featured() {
  const banner = document.querySelector('.featured-blog-banner');
  if (!banner) return;
  const sectionRoot = banner.closest(".hero") || document;
  const mode = banner.getAttribute('mode');
  if (mode === 'manual') return;
  const isNightMode = Boolean(document.querySelector(".night-light.active"));
  const data = isNightMode ? window.night?.settings : window.kitchen?.settings;

  // Text + link for the active mode (idempotent, cheap to re-run on every call).
  if (data) {
    const contentNodes = sectionRoot.querySelectorAll(
      isNightMode ? ".dark-mode-content p" : ".light-mode-content p",
    );
    const ctaLinks = sectionRoot.querySelectorAll(
      isNightMode
        ? ".dark-mode-content a[href]"
        : ".light-mode-content a[href], .mobile-light-mode a[href]",
    );
    if (contentNodes[0]) contentNodes[0].innerText = data.title;
    if (contentNodes[1]) contentNodes[1].innerText = data.description;
    if (contentNodes[2]) contentNodes[2].innerText = data.title;
    if (contentNodes[3]) contentNodes[3].innerText = data.description;

    if (data.url) {
      ctaLinks?.forEach((link) => link.setAttribute("href", data.url));
      const sectionLink = banner
        .closest(".hero-wrapper")
        ?.querySelector(".hero__link");
      if (sectionLink) sectionLink.setAttribute("href", data.url);
    }
  }

  // Build BOTH mode containers exactly once and leave both in the DOM. Toggling
  // then only flips their visibility (see updateMediaMode) instead of destroying
  // and re-creating the active <img> from scratch — that rebuild forced a fresh
  // fetch/decode on every toggle, leaving the banner empty until it finished
  // (TNRS-166 follow-up). With both images already loaded, the swap is instant.
  if (featuredMediaBuilt) return;
  const mediaWrapper = sectionRoot.querySelector(".hero__media-wrapper");
  if (!mediaWrapper) return;

  mediaWrapper
    .querySelectorAll(".light-mode-media-container, .night-mode-media-container")
    .forEach((container) => container.remove());

  const dayContainer = window.kitchen?.settings
    ? buildFeaturedMediaContainer(false, window.kitchen.settings)
    : null;
  const nightContainer = window.night?.settings
    ? buildFeaturedMediaContainer(true, window.night.settings)
    : null;

  if (dayContainer) mediaWrapper.appendChild(dayContainer);
  if (nightContainer) mediaWrapper.appendChild(nightContainer);
  featuredMediaBuilt = true;

  // Apply current visibility now that both containers exist.
  const isDay = document.querySelector('.day-light.active');
  toggleDisplay('.light-mode-media-container', Boolean(isDay));
  toggleDisplay('.night-mode-media-container', !isDay);
}


document.addEventListener('DOMContentLoaded', updateMediaMode);

document.querySelectorAll('.day-light, .night-light').forEach(btn => {

  btn.addEventListener('click', updateMediaMode);
});

// Shopify / JS toggle safe
const observer = new MutationObserver(updateMediaMode);
observer.observe(document.body, {
  attributes: true,
  subtree: true,
  attributeFilter: ['class']
});

document.querySelector('body')?.classList.remove('blog-page-opacity');

// Theme editor support: on the storefront updateMediaMode() hides the inactive
// mode's content with inline display:none, which also hides the ".dark-mode-content"
// groups whenever day mode is active — the editor's default state. That left the
// "Desktop Dark Mode" / "Mobile Dark Mode" blocks display:none, so selecting them in
// the theme editor landed on a hidden element that never scrolled into view ("not
// loading"). When editing, switch the preview to the selected block's mode so it
// becomes visible and selectable. No effect on the live storefront.
if (window.Shopify && window.Shopify.designMode) {
  const setEditorMode = (night) => {
    document.querySelectorAll('.night-light').forEach(btn => btn.classList.toggle('active', night));
    document.querySelectorAll('.day-light').forEach(btn => btn.classList.toggle('active', !night));
    updateMediaMode();
  };

  const revealSelectedMode = (target) => {
    if (!target || !target.closest) return;
    if (target.closest('.dark-mode-content')) {
      setEditorMode(true);
    } else if (target.closest('.light-mode-content, .mobile-light-mode')) {
      setEditorMode(false);
    }
  };

  document.addEventListener('shopify:block:select', event => revealSelectedMode(event.target));
}
